import script from "./personal.vue?vue&type=script&setup=true&lang=js"
export * from "./personal.vue?vue&type=script&setup=true&lang=js"

import "./personal.vue?vue&type=style&index=0&id=1df21eaf&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df21eaf"]])

export default __exports__